/* Speed Junkies HQ - landing page Past Winners hydration.

   Reads the same /apps/api/winners endpoint the Hall of Fame gallery uses,
   so the three cards on the landing page always match the published winner
   record. Photos come from the winner's own media_urls, which is what stops
   a name ever being paired with the wrong car.

   This only runs when the section has "Use live winner data" switched on.
   It is off at the moment because the Manager app's M4 Competition record
   carries the wrong first name - see the note in sections/sj-lp-winners.liquid.

   If the request fails, times out, or returns nothing usable, the server
   rendered cards are simply left alone - the section never blanks out and
   never shows a half-empty grid.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-sj-lp-winners]');
  if (!root) return;
  if (root.getAttribute('data-live') !== 'true') return;

  var grid = root.querySelector('[data-sj-lp-winners-grid]');
  if (!grid) return;

  var limit = parseInt(root.getAttribute('data-limit'), 10);
  if (isNaN(limit) || limit < 1) limit = 3;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function photo(w) {
    var m = w && w.media_urls;
    if (!m) return '';
    if (typeof m === 'string') return m;
    if (Array.isArray(m)) {
      for (var i = 0; i < m.length; i++) {
        if (typeof m[i] === 'string' && /\.(jpe?g|png|webp)(\?|$)/i.test(m[i])) return m[i];
      }
    }
    return '';
  }

  function card(w) {
    var img = photo(w);
    var prize = w.prize_name || w.prize_desc || '';
    if (!img || !prize) return '';

    var name = [w.first_name, w.last_initial ? w.last_initial + '.' : ''].join(' ').trim();
    var alt = name ? name + ' with the ' + prize : prize;

    return (
      '<article class="sj-lp-winner">' +
        '<div class="sj-lp-winner__media">' +
          '<img src="' + esc(sized(img, 600)) + '" loading="lazy" decoding="async" width="600" height="450" alt="' + esc(alt) + '">' +
        '</div>' +
        '<div class="sj-lp-winner__body">' +
          '<p class="sj-lp-winner__prize">' + esc(prize) + '</p>' +
          '<p class="sj-lp-winner__who">' + esc(name || 'Recent Winner') + '</p>' +
        '</div>' +
      '</article>'
    );
  }

  var ctrl = ('AbortController' in window) ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);

  fetch('/apps/api/winners', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
    signal: ctrl ? ctrl.signal : undefined
  })
    .then(function (r) {
      if (!r.ok) throw new Error('winners ' + r.status);
      return r.json();
    })
    .then(function (data) {
      clearTimeout(timer);
      if (!data || data.success !== true || !Array.isArray(data.winners)) return;

      var list = data.winners
        .filter(function (w) { return w && w.approved === true; })
        .sort(function (a, b) {
          return new Date(b.win_date || 0) - new Date(a.win_date || 0);
        })
        .slice(0, limit);

      var html = list.map(card).filter(Boolean).join('');

      /* Only swap when we have a full set - a partial render would look
         worse than the accurate fallback already on the page. */
      if (list.length && html && html.split('<article').length - 1 === list.length) {
        grid.innerHTML = html;
      }
    })
    .catch(function () {
      clearTimeout(timer);
      /* keep the server rendered fallback */
    });
})();
